import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { GetVideosQuery, PostVideo, PutVideo, Video } from 'src/app/interfaces/api/video';
import { ApiService } from '../../core/api.service';

@Injectable({
  providedIn: 'root'
})
export class VideoService {

  private readonly path = 'videos';

  constructor(private apiService: ApiService) {}

  getVideos(query: GetVideosQuery): Observable<Video[]> {
    return this.apiService.getCollection(this.path, '', query);
  }

  postVideo(body: PostVideo): Observable<Video> {
    return this.apiService.postCollectionData(this.path, '', body);
  }

  putVideo(body: PutVideo): Observable<Video> {
    return this.apiService.updateCollection(this.path, '', body);
  }

  deleteVideo(id: string): Observable<{ message: string }> {
    return this.apiService.deleteCollectionItem(this.path, id);
  }

  deleteVideoByAttachment(attachmentId: string): Observable<{ message: string }> {
    return this.apiService.deleteCollectionItem(this.path, undefined, { attachment: attachmentId });
  }
}
